var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMail = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Envelope / Light / Solid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33337 2.5C1.95266 2.5 0.833374 3.61929 0.833374 5V15C0.833374 16.3807 1.95266 17.5 3.33337 17.5H16.6667C18.0474 17.5 19.1667 16.3807 19.1667 15V5C19.1667 3.61929 18.0474 2.5 16.6667 2.5H3.33337ZM5.53355 6.0265C5.17998 5.73187 4.65451 5.77964 4.35988 6.1332C4.06524 6.48676 4.11301 7.01224 4.46657 7.30687L8.3996 10.5844C9.32672 11.357 10.6734 11.357 11.6005 10.5844L15.5335 7.30687C15.8871 7.01224 15.9349 6.48676 15.6402 6.1332C15.3456 5.77964 14.8201 5.73187 14.4666 6.0265L10.5335 9.30402C10.2245 9.56156 9.77561 9.56156 9.46657 9.30403L5.53355 6.0265Z",
    fill: "#868AA5"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mail.b26b46c8ef7ff2a52a48ba64a6920408.svg";